import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Box, Typography } from '@material-ui/core'
import { Loader } from '../../Components'
import { TableOutline, Cards, OutlinedButton, Toggle } from '../../elements'

import { useStyles } from './style'
import Breadcrumb from '../../Components/Breadcrumbs'
import AccountDetails from './AccountDetails'
import { ACCOUNTDETAILS, PERSONALDETAILS, USERS } from './constant'
import PersonalDetails from './PersonalDetails'
import Users from './Users'

function Accounts(props) {
  const classes = useStyles()
  const [selectedToggle, setToggleValue] = useState((props.isSuperAdmin || props.isViewOnly) ? PERSONALDETAILS : ACCOUNTDETAILS)
  const toggleValues = [
    ...(!(props.isSuperAdmin || props.isViewOnly) ? [{
      label: 'Account Details',
      id: ACCOUNTDETAILS,
    }] : []),
    {
      label: 'Personal Details',
      id: PERSONALDETAILS,
    },
    {
      label: 'Users',
      id: USERS,
    }
  ]

  const getToggleValues = () => {
    return (
      <Box>
        {selectedToggle === 'accountdetails' ? <AccountDetails /> : selectedToggle === 'personaldetails' ? <PersonalDetails /> : <Users />}
      </Box>
    )
  }

  return (
    <Box>
      <Breadcrumb value={[{ 'Home': '/' }, { 'Accounts': '/accounts' }]} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Accounts</Typography>
      </Box>
      <Box className={classes.headerWrapper}>
        <Toggle list={toggleValues} selected={selectedToggle} onChange={setToggleValue} />
      </Box>

      <Cards className={classes.cardWrapper} children={getToggleValues()} />
    </Box>
  )
}

const mapStateToProps = ({ auth }) => {
  const { isSuperAdmin, isAdmin, isViewOnly } = auth
  return { isSuperAdmin, isAdmin, isViewOnly }
}
export default connect(mapStateToProps)(Accounts)